import React, { useEffect, useState, useMemo, useContext } from "react";
import LabelTopView from "../Utility/LabelTopView";
import { ChartBarBigIcon, CheckIcon, PencilIcon } from "lucide-react";
import HeaderWithButton from "../Utility/HeaderWithButton";
import TableHeader from "../Utility/TableHeader";
import { use } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Pagination } from "../../helper/HelperTwo";
import Select from "react-select";
import { useExcelDownload, usePDFDownload } from "../../helper/HelperTwo";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useToast } from "../../context/ToastProvider";
import { DataContext } from "../../helper/HelperOne";

const SalesOrderList = () => {
  const tabName = localStorage.getItem("tab_name");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [salesOrderList, setSalesOrderList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [filter, setFilter] = useState({
    sales_order_no: "",
    party_name: "",
    type_of_work: "",
    sales_or_service: tabName || "",
    sales_person: "",
    project_manager: "",
    labour_name: "",
    quotation_no: "",
    so_created_date_filter: "",
    so_date_from: "",
    so_date_to: "",
    date_filter: "",
    date_from: "",
    date_to: "",
  });
  const [salesmanData, setSalesmanData] = useState([]);
  const [workersData, setWorkersData] = useState([]);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const [projectManagerList, setProjectManagerList] = useState([]);
  const [salesOrderStatus, setSalesOrderStatus] = useState([]);
  const [salesOrderNumber, setSalesOrderNumber] = useState([]);
  const [salesOrderPartyName, setSalesOrderPartyName] = useState([]);
  const [filtersReset, setFiltersReset] = useState(false);
  const { PDFDownload } = usePDFDownload();
  const { excelDownload } = useExcelDownload();
  const [colors, setColors] = useState([]);
  const [editStatusRow, setEditStatusRow] = useState(null);
  const [statusValue, setStatusValue] = useState("");
  const [saleOrderStatus, setSaleOrderStatus] = useState([]);
  const { triggerToast } = useToast();
  const { searchData } = useContext(DataContext);

  const salesServiceOptions = [
    {
      value: "sales",
      name: "Sales",
    },
    {
      value: "service",
      name: "Service",
    },
  ];

  const fetchSaleOrder = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      let url = `public/api/sales-orders?page=${page}&sales_or_service=${tabName}`;
      if (searchData) {
        url += `&search=${searchData}`
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const [
        salesmanResponse,
        workersResponse,
        typeOfWorkResponse,
        projectManagerResponse,
        saleorderStatusResponse,
        saleOrderNumberResponse,
        saleOrderPartyResponse,
        salesOrderstatusList,
      ] = await Promise.all([
        axios.get("public/api/salesmen/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/workers/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/type-of-works/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/project-manager/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/sales-orders-status/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/sales-orders/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/sales-orders/party-name-list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get("public/api/sales-orders-status/list", {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setSaleOrderStatus(salesOrderstatusList?.data);
      setSalesOrderStatus(saleorderStatusResponse?.data);
      setSalesmanData(salesmanResponse?.data);
      setWorkersData(workersResponse?.data);
      setTypeOfWork(typeOfWorkResponse?.data);
      setProjectManagerList(projectManagerResponse?.data);
      setSalesOrderNumber(saleOrderNumberResponse?.data);
      setSalesOrderPartyName(saleOrderPartyResponse?.data);

      if (response?.data) {
        setSalesOrderList(response?.data?.salesOrders?.data);
        setCurrentPage(response?.data?.salesOrders?.current_page);
        setPagination(response?.data?.salesOrders);
      }
      const salesOrder = response?.data?.salesOrders?.data || [];
      const uniqueWorks = [
        ...new Set(salesOrder.map((q) => q.type_of_work).filter(Boolean)),
      ];
      const colorList = generateColors(uniqueWorks.length);
      setColors(colorList);

    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSaleOrder();
  }, [searchData]);

  const handleDownloadPDF = () => {
    const params = {
      sales_person: filter?.sales_person,
      project_manager: filter?.project_manager,
      labour_name: filter?.labour_name,
      type_of_work: filter?.type_of_work,
      sales_or_service: filter?.sales_or_service,
      sales_order_no: filter?.sales_order_no,
      party_name: filter?.party_name,
      quotation_no: filter?.quotation_no,
      so_created_date_filter: filter?.so_created_date_filter,
      so_date_from: filter?.so_date_from,
      so_date_to: filter?.so_date_to,
      date_filter: filter?.date_filter,
      date_from: filter?.date_from,
      date_to: filter?.date_to,
    };

    PDFDownload("sales-orders", "sales-orders.pdf", params, setLoading);
  }

  const handleDownloadExcel = () => {
    const params = {
      sales_person: filter?.sales_person,
      project_manager: filter?.project_manager,
      labour_name: filter?.labour_name,
      type_of_work: filter?.type_of_work,
      sales_or_service: filter?.sales_or_service,
      sales_order_no: filter?.sales_order_no,
      party_name: filter?.party_name,
      quotation_no: filter?.quotation_no,
      so_created_date_filter: filter?.so_created_date_filter,
      so_date_from: filter?.so_date_from,
      so_date_to: filter?.so_date_to,
      date_filter: filter?.date_filter,
      date_from: filter?.date_from,
      date_to: filter?.date_to,
    };


    excelDownload("sales-orders", "sales-orders.xlsx", params, setLoading);
  };


  const handleFilter = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams({
        page: page,
        sales_person: filter?.sales_person,
        project_manager: filter?.project_manager,
        labour_name: filter?.labour_name,
        type_of_work: filter?.type_of_work,
        sales_or_service: filter?.sales_or_service,
        sales_order_no: filter?.sales_order_no,
        party_name: filter?.party_name,
        quotation_no: filter?.quotation_no,
        so_created_date_filter: filter?.so_created_date_filter,
        so_date_from: filter?.so_date_from,
        so_date_to: filter?.so_date_to,
        date_filter: filter?.date_filter,
        date_from: filter?.date_from,
        date_to: filter?.date_to,
        search: searchData,
      }).toString();
      const response = await axios.get(
        "public/api/sales-orders?" + queryParams,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data) {
        setSalesOrderList(response?.data?.salesOrders?.data);
        setCurrentPage(response?.data?.salesOrders?.current_page);
        setPagination(response?.data?.salesOrders);

        const salesOrder = response?.data?.salesOrders?.data || [];
        const uniqueWorks = [
          ...new Set(salesOrder.map((q) => q.type_of_work).filter(Boolean)),
        ];
        const colorList = generateColors(uniqueWorks.length);
        setColors(colorList);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
    } finally {
      setLoading(false);
    }
  };
  const handlePageChange = (page) => {
    if (page !== "...") {
      fetchSaleOrder(page);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const resetFilters = () => {
    setLoading(true);
    setFilter({
      sales_person: "",
      project_manager: "",
      labour_name: "",
      type_of_work: "",
      sales_or_service: tabName || "",
      sales_order_no: "",
      party_name: "",
      quotation_no: "",
      so_created_date_filter: "",
      so_date_from: "",
      so_date_to: "",
      date_filter: "",
      date_from: "",
      date_to: "",
    });
    setLoading(false);
    setFiltersReset(true);
  };

  useEffect(() => {
    if (filtersReset) {
      fetchSaleOrder();
      setFiltersReset(false);
    }
  }, [filtersReset]);


  const randomColorMap = useMemo(() => {
    const map = {};
    if (!salesOrderList || salesOrderList.length === 0 || !colors?.length) return map;

    const uniqueWorks = [
      ...new Set(salesOrderList.map((lead) => lead?.type_of_work).filter(Boolean)),
    ];

    uniqueWorks.forEach((work, index) => {
      map[work] = colors[index % colors.length]; // assign color deterministically
    });

    return map;
  }, [salesOrderList, colors]);

  const generateColors = (count) => {
    const colors = [];

    for (let i = 0; i < count; i++) {
      const hue = Math.floor(Math.random() * 360); // full color range
      const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% = very colorful
      const lightness = Math.floor(Math.random() * 30) + 20; // 60–90% = bright

      const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      colors.push(color);
    }

    return colors;
  };


  const handleUpdateStatus = async (id_crypt, sent_status = false) => {
    setLoading(true);
    let params = {
      status_id: statusValue,
    };
    try {
      const response = await axios.put(
        `public/api/sales-orders/status/update/${id_crypt}`,
        params, // request body
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      triggerToast("success", "Status updated successfully"); // optional success message
      handleFilter(currentPage); // Refresh the list to show updated status
    } catch (error) {
      triggerToast(
        "error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  }

  const headers = [
    "S No",
    "Quote No",
    "Sales Order No",
    "Party Name",
    "Mobile No",
    "Type Of Work",
    "Sales/Service",
    "Sales Person",
    "Project Manager",
    "Labour Name",
    "Sale Ledger",
    "Sync Status",
    "Sales Order Created Date",
    "Sales Order Amount",
    "OverDue Days",
    "Status",
  ];

  if (loading) {
    return (
      <div className="h-screen bg-white">
        <div className="flex justify-center items-center h-full">
          <img
            className="h-16 w-16"
            src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  }

  if (error) {
    <div className="h-screen bg-white flex flex-col justify-center items-center">
      <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
      <button
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        onClick={() => {
          setError(null); // hide error while retrying
          fetchSaleOrder(); // retry API
        }}
      >
        Reload
      </button>
    </div>;
  }
  return (
    <div>
      <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
        <div className="flex-1">
          <LabelTopView
            label="Sales Order Overview"
            icon={<ChartBarBigIcon />}
          />
        </div>
      </div>

      <HeaderWithButton
        title="Sales Order List"
        description="Sales Order"
        buttonText="Sales Order"
        // onButtonClick={handleAddLead}
        showButton={false}
      />

      <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mt-4">
        {/* Date filter */}

        {/* salesman Dropdown */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales Person
          </label>
          <Select
            name="sales_person"
            options={salesmanData?.map((cust) => ({
              value: cust.name,
              label: cust.name,
            }))}
            value={
              salesmanData
                ?.map((cust) => ({
                  value: cust.name,
                  label: cust.name,
                }))
                .find((cust) => cust.value === filter.sales_person) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_person",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Sales Person"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Project Manager
          </label>
          <Select
            name="project_manager"
            options={projectManagerList?.map((cust) => ({
              value: cust?.name,
              label: cust?.name,
            }))}
            value={
              projectManagerList
                ?.map((cust) => ({
                  value: cust?.name,
                  label: cust?.name,
                }))
                .find((cust) => cust.value === filter?.project_manager) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "project_manager",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Project Manager"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Labour
          </label>
          <Select
            name="worker_tally_id"
            options={workersData?.map((cust) => ({
              value: cust.name,
              label: cust.name,
            }))}
            value={
              workersData
                ?.map((cust) => ({
                  value: cust.name,
                  label: cust.name,
                }))
                .find((cust) => cust.value === filter.labour_name) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "labour_name",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Labour"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type of Work
          </label>
          <Select
            name="type_of_work"
            options={typeOfWork?.map((work) => ({
              value: work.name,
              label: work.name,
            }))}
            value={
              // Find the option where option.value matches filter.type_of_work
              typeOfWork
                ?.map((work) => ({ value: work.name, label: work.name }))
                .find((option) => option.value === filter.type_of_work) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "type_of_work",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Type of Work"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales / Service
          </label>
          <Select
            name="sales_or_service"
            options={salesServiceOptions?.map((item) => ({
              value: item.value,
              label: item.name,
            }))}
            value={
              salesServiceOptions
                ?.map((item) => ({
                  value: item.value,
                  label: item.name,
                }))
                .find((option) => option.value === filter.sales_or_service) ||
              null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_or_service",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Sales / Service"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales Order Status
          </label>
          <Select
            name="sales_or_service"
            options={salesOrderStatus?.map((item) => ({
              value: item?.status,
              label: item?.status,
            }))}
            value={
              salesOrderStatus
                ?.map((item) => ({
                  value: item?.status,
                  label: item?.status,
                }))
                .find((option) => option.value === filter.sales_or_service) ||
              null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_or_service",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Status"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales Order No
          </label>
          <Select
            name="sales_order_no"
            options={salesOrderNumber?.map((item) => ({
              value: item.sales_order_no,
              label: item.sales_order_no,
            }))}
            value={
              salesOrderNumber
                ?.map((item) => ({
                  value: item.sales_order_no,
                  label: item.sales_order_no,
                }))
                .find((option) => option.value === filter.sales_order_no) ||
              null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_order_no",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Status"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        {/* <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Party Name
                    </label>
                    <Select
                        name="party_name"
                        options={salesOrderPartyName?.map((item) => ({
                            value: item.party_name,
                            label: item.party_name,
                        }))}
                        value={
                            salesOrderPartyName
                                ?.map((item) => ({
                                    value: item.party_name,
                                    label: item.party_name,
                                }))
                                .find((option) => option.value === filter.party_name) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "party_name",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Status"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div> */}

        {/* <div className="space-y-3 ">
                 
                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Status
                        </label>
                        <select
                            name="status"
                            value={filter?.status}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="1. Win">1. Win</option>
                            <option value="2. Follow-up">2. Follow-up</option>
                            <option value="3. Lost">3. Lost</option>
                            <option value="4. Negotiation">4.Negotiation</option>
                        </select>
                    </div>
                </div> */}

        {/* <div className="space-y-3 ">
                    
                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Quote Sent Status
                        </label>
                        <select
                            name="quote_sent_status"
                            value={filter?.quote_sent_status}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div> */}

        <div className="space-y-3 ">
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Sales Order Create Date
            </label>
            <select
              name="so_created_date_filter"
              value={filter?.so_created_date_filter}
              onChange={handleChange}
              className="border border-gray-300 p-2 rounded w-full mt-2"
            >
              <option value="" className="text-gray-300">
                -- Select --
              </option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="this_week">This Week</option>
              <option value="this_month">This Month</option>
              <option value="this_year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>
        </div>

        {filter.so_created_date_filter === "custom" && (
          <>
            <div className="space-y-3 ">
              <div className="">
                <label className="block text-sm font-medium">Date From</label>
                <input
                  type="date"
                  name="so_date_from"
                  value={filter.so_date_from}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
            <div className="space-y-3 ">
              <div className="w-full">
                <label className="block text-sm font-medium">Date To</label>
                <input
                  type="date"
                  name="so_date_to"
                  value={filter.so_date_to}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
          </>
        )}

        <div className="space-y-3 ">
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Create Date
            </label>
            <select
              name="date_filter"
              value={filter.date_filter}
              onChange={handleChange}
              className="border border-gray-300 p-2 rounded w-full mt-2"
            >
              <option value="" className="text-gray-300">
                -- Select --
              </option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="this_week">This Week</option>
              <option value="this_month">This Month</option>
              <option value="this_year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>
        </div>

        {filter.date_filter === "custom" && (
          <>
            <div className="space-y-3 ">
              <div className="">
                <label className="block text-sm font-medium">Date From</label>
                <input
                  type="date"
                  name="date_from"
                  value={filter.date_from}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
            <div className="space-y-3 ">
              <div className="w-full">
                <label className="block text-sm font-medium">Date To</label>
                <input
                  type="date"
                  name="date_to"
                  value={filter.date_to}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="flex flex-wrap gap-4 mt-4">
        {/* Submit Button */}
        <button
          // ref={submitBtnRef}
          onClick={() => handleFilter(1)}
          className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
        >
          Submit
        </button>

        {/* Reset Button */}
        <button
          onClick={resetFilters}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          Reset
        </button>
        <button
          onClick={handleDownloadPDF}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          PDF
        </button>

        <button
          onClick={handleDownloadExcel}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          Excel
        </button>
      </div>

      <div className="overflow-x-auto mt-8">
        <table className="min-w-full border border-gray-300 border-collapse">
          <TableHeader headers={headers} />
          <tbody>
            {salesOrderList.length > 0 ? (
              salesOrderList?.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center">
                    {pagination.from + index}
                  </td>
                  {/* <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.enquiry_no || "N/A"}
                                    </td> */}
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.quotation_no || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.sales_order_no || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.party_name || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5">


                    {/* <a href={`tel:${item?.mobile_no}`}>
                      {" "}
                      {item?.mobile_no || "N/A"}{" "}
                    </a> */}

                    {item?.mobile_no ? (
                      <a href={`tel:${item.mobile_no}`}>
                        {item.mobile_no}
                      </a>
                    ) : (
                      <span className="text-gray-400">N/A</span>
                    )}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {/* {item?.type_of_work || "N/A"} */}
                    <span
                      className="text-xs rounded px-1"
                      style={{
                        color: randomColorMap[item.type_of_work],
                        border: `1px solid ${randomColorMap[item.type_of_work]
                          }`,
                      }}
                    >
                      {item.type_of_work || "N/A"}
                    </span>
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.sales_or_service || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.sales_person || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.project_manager || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.labour_name || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.sales_ledger || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.sync_status || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.so_create_date
                      ? new Date(item?.so_create_date).toLocaleDateString(
                        "en-GB"
                      )
                      : "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.sales_order_amount || "0.00"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {item?.over_due_by_days || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">


                    {editStatusRow !== item.id_crypt ? (
                      <div className="flex items-center justify-center space-x-2">
                        <span>{item?.sales_order_status?.status || "N/A"}</span>
                        <PencilIcon
                          className="w-6 h-6 text-white bg-green-500 hover:bg-green-600 p-1 rounded cursor-pointer"
                          onClick={() => {
                            setEditStatusRow(item.id_crypt); // set this row to edit mode
                            setStatusValue(item?.sales_order_status?.status || ""); // initialize value
                          }}
                        />
                      </div>
                    ) : (
                      <div className="flex items-center justify-center space-x-2">
                        <select
                          value={statusValue}
                          onChange={(e) => setStatusValue(e.target.value)}
                          className="border border-gray-300 rounded-md p-1 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        >
                          <option value="">Select</option>
                          {saleOrderStatus?.map((option) => (
                            <option key={option?.id} value={option?.id}>
                              {option?.status}
                            </option>
                          ))}
                        </select>

                        <CheckIcon
                          className="w-6 h-6 text-white bg-blue-500 hover:bg-blue-600 p-1 rounded cursor-pointer"
                          onClick={() => {
                            handleUpdateStatus(item.id_crypt);
                            setEditStatusRow(null); // exit edit mode after updating
                          }}
                        />
                        <XMarkIcon
                          className="w-6 h-6 text-white bg-red-500 hover:bg-red-600 p-1 rounded cursor-pointer"
                          onClick={() => setEditStatusRow(null)} // cancel editing
                        />
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="text-center py-4">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {pagination && (
        <Pagination
          links={pagination.links}
          currentPage={pagination.current_page}
          totalResults={pagination.total}
          from={pagination.from}
          to={pagination.to}
          lastPage={pagination.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default SalesOrderList;
